export default __webpack_public_path__ + "static/media/TarantiaNobleDistrict.6ef16baf.jpg";